
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/posts/2014-07-08-spruce-street-harbor",
      function () {
        return require("private-next-pages/posts/2014-07-08-spruce-street-harbor.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/posts/2014-07-08-spruce-street-harbor"])
      });
    }
  